export const objectToQuery = obj => {
    return new URLSearchParams(obj).toString();
};
